import _ from 'lodash';
import {
  FlightFareSources,
  FlightSearchTypes,
  LocationTypes,
  maxLayoverDuration,
  minLayoverDuration,
} from '../constants';

const formatFlightSegmentRequest = (
  flightSegments,
  flightSearchType,
  searchInputs,
  selectedFlightSegments,
) => {
  const request = {};
  flightSegments.forEach((st, index) => {
    if (flightSearchType === FlightSearchTypes.ONE_WAY && index > 0) return;
    if (flightSearchType === FlightSearchTypes.ROUND_TRIP && index > 1) return;

    if (st.leaveDate) {
      request[`segments[${index}].leaveDate`] = st.leaveDate;
    }
    if (st.preferredCabin) {
      request[`segments[${index}].preferredCabin`] = st.preferredCabin;
    }
    if (st.timePreference) {
      request[`segments[${index}].timePreference`] = st.timePreference;
    }
    if (st.flightTime) {
      request[`segments[${index}].flightTime`] = st.flightTime;
    }
    if (st.departureTimeWindow) {
      request[`segments[${index}].departureTimeWindow`] = st.departureTimeWindow;
    }
    if (st.arrivalTimeWindow) {
      request[`segments[${index}].arrivalTimeWindow`] = st.arrivalTimeWindow;
    }
    if (
      st.maxLayoverDuration &&
      st.maxLayoverDuration < maxLayoverDuration &&
      st.maxLayoverDuration > minLayoverDuration
    ) {
      request[`segments[${index}].maxLayoverDuration`] = st.maxLayoverDuration;
    }
    if (
      st.minLayoverDuration &&
      st.minLayoverDuration > minLayoverDuration &&
      st.minLayoverDuration < maxLayoverDuration
    ) {
      request[`segments[${index}].minLayoverDuration`] = st.minLayoverDuration;
    }

    if (st.airlines && searchInputs && searchInputs.hasDifferentOutboundInboundAirLine) {
      const airlines = st.airlines && st.airlines.map((x) => x.value);
      request[`segments[${index}].airlines`] = airlines;
    }
    if (
      st.alliances &&
      st.alliances.length &&
      searchInputs &&
      searchInputs.hasDifferentOutboundInboundAlliance
    ) {
      const alliances = st.alliances && st.alliances.map((x) => x.value);
      request[`segments[${index}].alliances`] = alliances;
    }
    if (st.connectingAirports && st.connectingAirports.length) {
      const connectingAirports =
        st.connectingAirports && st.connectingAirports.map((x) => x.airportCode);
      request[`segments[${index}].connectingAirports`] = connectingAirports;
      request[`segments[${index}].connectingAirportsPreference`] = st.connectingAirportsPreference;
    }
    let originLocation = st.origin;
    if (!originLocation && flightSearchType === FlightSearchTypes.ROUND_TRIP && index === 1) {
      originLocation = flightSegments[0].destination;
    }
    if (originLocation) {
      if (originLocation.value) {
        if (originLocation.locationType === LocationTypes.PORT_OF_DEPARTURE) {
          request[`segments[${index}].origin.departureCityId`] = originLocation.value;
        } else if (originLocation.airportCode && originLocation.airportCode.trim() !== '') {
          request[`segments[${index}].origin.airportCode`] = originLocation.airportCode;
        } else {
          request[`segments[${index}].origin.geoIndex`] = originLocation.value;
          if (originLocation.featureClass)
            request[`segments[${index}].origin.featureClass`] = originLocation.featureClass;
        }
      }
      if (originLocation.airportCode)
        request[`segments[${index}].origin.airportCode`] = originLocation.airportCode;
      if (originLocation.airportCode && originLocation.type)
        request[`segments[${index}].origin.type`] = originLocation.type;
      if (originLocation.latitude)
        request[`segments[${index}].origin.latitude`] = originLocation.latitude;
      if (originLocation.longitude)
        request[`segments[${index}].origin.longitude`] = originLocation.longitude;
    }

    let destinationLocation = st.destination;
    if (!destinationLocation && flightSearchType === FlightSearchTypes.ROUND_TRIP && index === 1) {
      destinationLocation = flightSegments[0].origin;
    }
    if (destinationLocation) {
      if (destinationLocation.value) {
        if (destinationLocation.locationType === LocationTypes.PORT_OF_DEPARTURE) {
          request[`segments[${index}].destination.departureCityId`] = destinationLocation.value;
        } else if (
          destinationLocation.airportCode &&
          destinationLocation.airportCode.trim() !== ''
        ) {
          request[`segments[${index}].destination.airportCode`] = destinationLocation.airportCode;
        } else {
          request[`segments[${index}].destination.geoIndex`] = destinationLocation.value;
          if (destinationLocation.featureClass)
            request[`segments[${index}].destination.featureClass`] =
              destinationLocation.featureClass;
        }
      }
      if (destinationLocation.airportCode)
        request[`segments[${index}].destination.airportCode`] = destinationLocation.airportCode;
      if (destinationLocation.airportCode && destinationLocation.type)
        request[`segments[${index}].destination.type`] = destinationLocation.type;
      if (destinationLocation.latitude)
        request[`segments[${index}].destination.latitude`] = destinationLocation.latitude;
      if (destinationLocation.longitude)
        request[`segments[${index}].destination.longitude`] = destinationLocation.longitude;
    }
    if (
      selectedFlightSegments &&
      selectedFlightSegments[index] &&
      selectedFlightSegments[index].flights &&
      index < flightSegments.length - 1
    ) {
      request[`segments[${index}].doSelectedFlightHaveNDC`] = !!_.find(
        selectedFlightSegments[index].flights,
        (f) => !!_.find(f.allFares, (fr) => fr.pricingSubsource === FlightFareSources.NDC),
      );
      selectedFlightSegments[index].flights.forEach((flightSegment, flightIndex) => {
        request[`segments[${index}].selectedFlights[${flightIndex}].originLocation`] =
          flightSegment.originAirportCode;
        request[`segments[${index}].selectedFlights[${flightIndex}].destinationLocation`] =
          flightSegment.destinationAirportCode;
        request[`segments[${index}].selectedFlights[${flightIndex}].arrivalDateTime`] =
          flightSegment.arriveDateTime;
        request[`segments[${index}].selectedFlights[${flightIndex}].departureDateTime`] =
          flightSegment.departDateTime;
        request[`segments[${index}].selectedFlights[${flightIndex}].flightNumber`] =
          +flightSegment.flightNumber;
        request[`segments[${index}].selectedFlights[${flightIndex}].airline.marketingAirlineCode`] =
          flightSegment.carrierCode;
        request[`segments[${index}].selectedFlights[${flightIndex}].airline.operatingAirlineCode`] =
          flightSegment.operatingAirline && flightSegment.operatingAirline.code;

        let classOfService = flightSegment.fareClass;
        const { selectedFareIndex } = selectedFlightSegments[index];
        if (
          selectedFareIndex &&
          flightSegment.allFares &&
          flightSegment.allFares[selectedFareIndex]
        ) {
          classOfService = flightSegment.allFares[selectedFareIndex].fareClass;
        }
        request[`segments[${index}].selectedFlights[${flightIndex}].classOfService`] =
          classOfService;

        let contextFare = flightSegment.allFares && flightSegment.allFares[0];
        if (
          selectedFareIndex &&
          flightSegment.allFares &&
          flightSegment.allFares[selectedFareIndex]
        ) {
          contextFare = flightSegment.allFares[selectedFareIndex];
        }
        const offerContext = contextFare && contextFare.offerContext;
        if (
          offerContext &&
          offerContext.searchCacheGuid &&
          offerContext.catalogProductOfferingIds &&
          offerContext.catalogProductOfferingIds.length &&
          offerContext.productRefs &&
          offerContext.productRefs.length
        ) {
          // A leg-search card carries single-slot id arrays; a full-itinerary card carries one
          // slot per leg - clamp so both shapes resolve.
          const slot = Math.min(index, offerContext.catalogProductOfferingIds.length - 1);
          request[`segments[${index}].selectedFlights[${flightIndex}].searchCacheGuid`] =
            offerContext.searchCacheGuid;
          request[`segments[${index}].selectedFlights[${flightIndex}].catalogProductOfferingId`] =
            offerContext.catalogProductOfferingIds[slot];
          request[`segments[${index}].selectedFlights[${flightIndex}].productRef`] =
            offerContext.productRefs[slot];
        }
      });
    }
  });
  return request;
};

export default formatFlightSegmentRequest;
